import React from 'react';
import { shape, string } from 'prop-types';
import BaseTile from 'components/tiles/BaseTile';
import BgImgTile from 'components/tiles/BgImgTile';
import ArticleTile from 'components/tiles/ArticleTile';
import CourseTile from 'components/tiles/CourseTile';
import EventListing from 'components/event-listing/EventListing';
import ElectiveListing from 'components/elective-listing/ElectiveListing';
import FacultyListing from 'components/faculty-listing/FacultyListing';
import CourseListing from 'components/course-listing/CourseListing';

export default function ListingItem({ item, tileType }) {
    // Determine which tile component gets rendered
    switch (tileType) {
        case 'bgImg':
            return (
                <BgImgTile item={item} />
            );
        // add more below...
        case 'article':
            return (
                <ArticleTile item={item} />
            );

        case 'eventListing':
            return (
                <EventListing item={item} />
            );

        case 'facultyListing':
            return (
                <FacultyListing item={item} />
            );

        case 'electiveListing':
            return (
                <ElectiveListing item={item} />
            );

        case 'courseListing':
            return (
                <CourseListing item={item} />
            );

        case 'courseTile':
            return (
                <CourseTile item={item} />
            );

        default:
            return (
                <BaseTile item={item} />
            );
    }
}

ListingItem.propTypes = {
    item: shape({ title: string.isRequired }).isRequired,
    tileType: string.isRequired
};
